import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../services/prod/i18n.service'

export type GoodType = {
  id: number
  title: string
  src: string
  price: number
}

@Component({
  selector: 'bmcore-goods-block',
  templateUrl: './bmcore-goods-block.component.html',
  styleUrls: ['bmcore-goods-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGoodsBlockComponent implements OnInit {
  lg: LgType
  goods: Array<GoodType> = [
    {
      id: 1,
      title: 'Drum Kit dolor sit amet, consectetur adipisicing elit. Consequuntur, corporis!',
      src: 'drum-kit-sub.jpg',
      price: 1000
    },
    {
      id: 2,
      title: 'Piano sit amet, consectetur adipisicing elit. Molestias nobis porro quas quos, soluta tempora.',
      src: 'piano-stub.jpg',
      price: 1500
    },
    { id: 3, title: 'ProducerName Vocal Samples Volume 1', src: 'vocal-stub.jpg', price: 500 },
    { id: 4, title: 'Sample Pack', src: 'violin-stub.jpg', price: 1500 }
  ]

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getGoods()
  }

  getGoods() {
    return this.goods
  }
}
